"use client";

import DetailRouteErrorState from "@/containers/website/hotel/detail-v2/components/DetailRouteErrorState";

export default function HotelDetailPageError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <DetailRouteErrorState onRetry={reset} />;
}
